<template>
  <v-container>
    <v-row class="text-justify">
      <v-col cols="12" v-html="dynamicContent&&dynamicContent.agb">
      </v-col>
      <v-col cols="12" class="mb-12">
        <div v-html="$t('delivery.lang_agbContent')"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

export default {
  name: "AGBComponent",
  computed:{
    ...createNamespacedHelpers("Config").mapGetters(["dynamicContent",]),
  }
};
</script>
